/**
 * Persistence for the account's chosen hat (SPEC.md: "The choice persists across
 * visits"). We keep it lightweight: the last hat the person switched to is saved
 * in localStorage and read back on the next visit. The server derives the set of
 * hats an account has; this only remembers which one to open in, and a stale or
 * unavailable value is always re-validated by resolveActiveHat before use.
 *
 * All access is wrapped in try/catch and guarded for environments without
 * localStorage (private mode, tests) so reading or writing the preference can
 * never break the app.
 */

const HAT_KEY = 'proteam.hat';

/** The persisted hat choice, or null when none is stored or storage is blocked. */
export function readStoredHat(): string | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem(HAT_KEY);
  } catch {
    return null;
  }
}

/** Remember the chosen hat. Silently no-ops when storage is unavailable. */
export function writeStoredHat(hat: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(HAT_KEY, hat);
  } catch {
    // Persistence is a nicety; losing it must never surface an error.
  }
}
